/**
 * CandidateLayout - Minimal layout for the candidate portal.
 * No admin sidebar. Clean, focused on the candidate experience.
 */
export default function CandidateLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#0b0e1a] text-white">
      {/* Minimal header */}
      <header className="border-b border-slate-800 px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-violet-600 flex items-center justify-center text-white font-bold text-sm">
            L
          </div>
          <span className="font-semibold text-white">Lenvia</span>
          <span className="text-slate-600">·</span>
          <span className="text-slate-400 text-sm">Espace Candidat</span>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10">{children}</main>
    </div>
  );
}
